
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5 17a8.5 8.5 0 100-17 8.5 8.5 0 000 17z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M21 12h-1a8 8 0 01-8 8v2c5.523 0 10-4.477 10-10h-1zm-9 9v-1a8 8 0 01-8-8H2c0 5.523 4.477 10 10 10v-1zm-9-9h1a8 8 0 018-8V2C6.477 2 2 6.477 2 12h1zm9-9v1a8 8 0 018 8h2c0-5.523-4.477-10-10-10v1zm0 11h-1v7h2v-7h-1zm0-11h-1v7h2V3h-1zm7.794 13.5l.5-.866-6.062-3.5-.5.866-.5.866 6.062 3.5.5-.866zM10.268 11l.5-.866-6.062-3.5-.5.866-.5.866 6.062 3.5.5-.866zm3.464 0l.5.866 6.062-3.5-.5-.866-.5-.866-6.062 3.5.5.866zm-9.526 5.5l.5.866 6.062-3.5-.5-.866-.5-.866-6.062 3.5.5.866zM14 12h-1a1 1 0 01-1 1v2a3 3 0 003-3h-1zm-2 2v-1a1 1 0 01-1-1H9a3 3 0 003 3v-1zm-2-2h1a1 1 0 011-1V9a3 3 0 00-3 3h1zm2-2v1a1 1 0 011 1h2a3 3 0 00-3-3v1z","fill":"#4A4A4A"}})])
          )
        }
      }
    